import { createRouter, createWebHistory } from 'vue-router'
import { homeRoute } from '@/modules/home/routes'
// import { loginRoute } from '@/modules/auth/routes'
import { http } from '@/http'
import * as toast from '@/helpers/useToast'
import { storeApp } from '@/store'
import { profileRoute } from '@/modules/profile/routes'
import { clientRoutes } from '@/modules/clients/routes'
import { movimentRoutes } from '@/modules/moviment/routes'
import { releasesRoutes } from '@/modules/releases/routes'
import { productsRoutes } from '@/modules/products/routes'
import { collabRoutes } from '@/modules/collaborators/routes'
import { companyRoute } from '@/modules/company/routes'
import { costRoute } from '@/modules/costs/routes'
import { loginRoutes } from '@/modules/login/router'
import { schedulingRoutes, clientSchedulingLink } from '@/modules/scheduling/routes'
import authService from '@/modules/auth/services/auth.service'

const routes = [
  ...homeRoute,
  // ...loginRoute,
  ...profileRoute,
  ...clientRoutes,
  ...movimentRoutes,
  ...releasesRoutes,
  ...productsRoutes,
  ...collabRoutes,
  ...companyRoute,
  ...costRoute,
  ...loginRoutes,
  ...schedulingRoutes,
  ...clientSchedulingLink
]

const router = createRouter({
  history: createWebHistory('#'),
  routes
})

router.beforeEach(async (to, from, next) => {
  storeApp.state.loading = true

  if (to.name === 'logout') {
    return authService.logout()
      .then((res) => {
        storeApp.dispatch('hiddenMenuUserLoggedOut')
        storeApp.dispatch('setUserAuthenticated', false)

        toast.showToast(
          'Até logo!', 
          'Deslogado com sucesso',
          'success' 
        )
        next({ name: 'login' })
      })
      .catch((err) => {
        toast.showToast(
          'Aviso',
          'Algo deu errado!', 
          'error' 
        )
        next({ name: 'login' })
      })
  }

  // verifica as permissões para acessar a página
  if (to.meta.key) {
    const userPermissions = localStorage.getItem('__permissions')

    if (userPermissions) {
      const permissionsArray = userPermissions.split(',')

      // Se meta.key for uma string, verifica se a permissão está no localStorage
      if (typeof to.meta.key === 'string') {
        if (!permissionsArray.includes(to.meta.key)) {
          if (from.name !== 'login') {
            toast.showToast(
              'BarbApp informa:', 
              'Você não tem permissão para acessar essa página', 
              'info'
            )
          }

          // redireciona caso não tenha permissão
          next({ name: 'releases' })
        }
      }

      // Se meta.key for um array, verifica se pelo menos uma permissão está no localStorage
      if (Array.isArray(to.meta.key)) {
        const hasPermission = to.meta.key.some(key => permissionsArray.includes(key))

        if (!hasPermission) {
          if (from.name !== 'login') {
            toast.showToast(
              'BarbApp informa:', 
              'Você não tem permissão para acessar essa página', 
              'info'
            )
          }
          next({ name: 'releases' })
        }
      }
    }
  }

  // vai para a pagina de agendamento do cliente
  if (to.name === 'client-scheduling' && to.params.cId) {
    // garante que o menu não apareça
    storeApp.dispatch('hiddenMenuUserLoggedOut')

    storeApp.state.accessToken.clear()
    storeApp.state.loading = false
    return next()
  }

  const routeNamesToCheck = ['login', 'login-sign-in', 'login-sign-up', 'login-forgot', 'confirm-code', 'client-scheduling']
  const isMainRouteValid = routeNamesToCheck.includes(to?.name)
  const isChildRouteValid = to?.matched.some(record =>
    record?.children && record?.children.some(child => routeNamesToCheck.includes(child?.name))
  )

  if (!isMainRouteValid || !isChildRouteValid) {
    try {
      await http.get(process.env.VUE_APP_API_URL.concat('auth/me'))
      storeApp.state.loading = false
      next()
    } catch (error) {
      toast.showToast(
        'Aviso', 
        'Sua sessão expirou', 
        'error'
      )

      storeApp.state.loading = false
      storeApp.dispatch('hiddenMenuUserLoggedOut')
      storeApp.dispatch('setUserAuthenticated', false)

      if (to.query.indicatedBy) {
        next({ name: 'login-sign-up', query: { indicatedBy: to.params.indicatedBy } })
      } else {
        next({ name: 'login' })
      }
    }
  } else {
    storeApp.dispatch('setUserAuthenticated', false)
    storeApp.state.accessToken.clear()
    storeApp.state.loading = false
    next()
  }
})

export default router
